<template>
  <span
    class="notification-kind-badge"
    :class="modifierClass"
    :data-testid="dataTestid"
  >
    <v-icon small class="mr-1">{{ icon }}</v-icon>
    {{ label }}
  </span>
</template>

<script>
import { NOTIFICATION_KIND_ICON, NOTIFICATION_KIND_LABEL } from '../../../utils/constants';

export default {
  name: 'NotificationKindBadge',
  props: {
    kind: { type: String, default: 'schedule' },
    dataTestid: { type: String, default: 'notification-kind-badge' },
  },
  computed: {
    label() {
      return NOTIFICATION_KIND_LABEL[this.kind] || this.kind;
    },
    icon() {
      return NOTIFICATION_KIND_ICON[this.kind] || 'mdi-clock-outline';
    },
    modifierClass() {
      return `notification-kind-badge--${this.kind}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './NotificationKindBadge.scss';
</style>
